/** Status values as the gateway returns them. */
export enum ComponentStatus {
  Up = 'UP',
  Down = 'DOWN',
}
